/* eslint-disable camelcase */
import Api from '../api';

const createRdConversion = (conversion: string, dados?: object, email?: string) => {
  const payload: { conversion: string; dados?: object; email?: string } = {
    conversion,
  };

  if (dados && Object.keys(dados).length > 0) payload.dados = dados;
  if (email) payload.email = email;

  return Api.post('/rd_conversions', payload);
};

export default createRdConversion;
